import { writable } from 'svelte/store';

export let connected = writable(null);
export let city = writable(null);

export let user = writable(null);
export let token = writable(null);
export let alerts = writable(null);

export let profilData = writable(null);

export let isConnectedVar = writable(null);

//recaptcha V2
export const googleRecaptchaSiteKey = "6LcYT9ccAAAAAHOMe0sjmWUsM_y8xJLCjScCWEcf";

//recaptcha V3
//export const googleRecaptchaSiteKey = "6LfDIS4eAAAAAI1DpPobj4T_zl9VE0_AmsgT83D4";